import { Carousel } from "@aisquare/ui";
import { Section, VariantBlock } from "../lib/Section";

const IMG = (seed: string) => `https://picsum.photos/seed/${seed}/320/200`;

export function CarouselDemo() {
  return (
    <Section
      id="carousel"
      title="Carousel"
      description="Horizontal scroller of compact cards. Renderer for the K2 `carousel` block - props are `{ title?, description?, items: [{id, name, subtitle?, image?, actions?}] }`. Interactive when cards carry actions; nested block_refs render via the shared child resolver `grid` uses."
    >
      <VariantBlock label="Card items">
        <div className="w-full max-w-2xl">
          <Carousel
            title="Recommended studios"
            description="Picked for you"
            items={[
              { id: "1", name: "AI Math Tutor", subtitle: "Adaptive practice for grades 6-12", image: IMG("math") },
              { id: "2", name: "Resume Coach", subtitle: "Tailored feedback in minutes", image: IMG("resume") },
              { id: "3", name: "Trip Planner", subtitle: "Itineraries with live pricing", image: IMG("trip") },
              { id: "4", name: "Code Reviewer", subtitle: "PR-grade review on demand", image: IMG("code") },
            ]}
          />
        </div>
      </VariantBlock>

      <VariantBlock label="Interactive (cards with actions)">
        <div className="w-full max-w-2xl">
          <Carousel
            title="Pick a template"
            items={[
              { id: "blank", name: "Blank studio", subtitle: "Start from scratch", actions: [{ id: "use", label: "Use" }] },
              { id: "quiz", name: "Quiz studio", subtitle: "Auto-graded questions", actions: [{ id: "use", label: "Use" }, { id: "preview", label: "Preview" }] },
            ]}
            onAction={(itemId, actionId) => alert(`item=${itemId} action=${actionId}`)}
          />
        </div>
      </VariantBlock>
    </Section>
  );
}
